import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import api from '../api';
import { 
  ON_CREATE_APPOINTMENTS,
  FETCH_APPOINTMENTS_DOCTORS,
  ON_DELETE_APPOINTMENTS,
  FETCH_APPOINTMENTS_BETWEEN_DATES
} from 'constants/ActionTypes';
import { userSignOut } from 'actions/Auth';
import { showAppointmentsLoader, saveAppointmentsSuccess, showAppointmentsMessage, fetchDoctorsSuccess, deleteAppointmentsSuccess, fetchAppointmentsBetweenDatesSuccess } from '../actions/Appointments';

function* getScheduleBetweenDates({ payload }) {
  try {
    const { startDate, endDate } = payload
    yield put(showAppointmentsLoader());
    const authToken = localStorage.getItem('token');
    const appointments = yield call(api.scheduleApi.getSchedule, { authToken, date: null, startDate, endDate });

    if (appointments.errorMessage) {
      yield put(showAppointmentsMessage(appointments.errorMessage, true));
    } else {
      yield put(fetchAppointmentsBetweenDatesSuccess(appointments));
    }
  } catch (error) {
    yield put(showAppointmentsMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* newSchedule({ payload }) {
  try {
    yield put(showAppointmentsLoader());
    const authToken = localStorage.getItem('token');
    
    let appointments = {}
    if (!payload.id) {
      appointments = yield call(api.scheduleApi.newSchedule, { payload, authToken });
    } else {
      appointments = yield call(api.scheduleApi.updateAppointments, { payload, authToken });
    }
    
    if (appointments.errorMessage) {
      yield put(showAppointmentsMessage(appointments.errorMessage, true));
    } else {
      yield put(saveAppointmentsSuccess(appointments));
    }
  } catch (error) {
    yield put(showAppointmentsMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* getDoctors() {
  try {
    yield put(showAppointmentsLoader());
    const authToken = localStorage.getItem('token');
    const doctors = yield call(api.scheduleApi.getDoctors, { authToken });

    if (doctors.errorMessage) {
      yield put(showAppointmentsMessage(doctors.errorMessage, true));
    } else {
      yield put(fetchDoctorsSuccess(doctors));
    }
  } catch (error) {
    yield put(showAppointmentsMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* deleteAppointments({ payload }) {
  try {
    yield put(showAppointmentsLoader());
    const authToken = localStorage.getItem('token');
    const appointments = yield call(api.scheduleApi.deleteAppointments, { payload, authToken });

    if (appointments.errorMessage) {
      yield put(showAppointmentsMessage(appointments.errorMessage, true));
    } else {
      yield put(deleteAppointmentsSuccess(payload.id));
    }
  } catch (error) {
    yield put(showAppointmentsMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

export function* fetchAppointmentsBetweenDates() {
  yield takeEvery(FETCH_APPOINTMENTS_BETWEEN_DATES, getScheduleBetweenDates);
}

export function* createSchedule() {
  yield takeEvery(ON_CREATE_APPOINTMENTS, newSchedule);
}

export function* fetchDoctors() {
  yield takeEvery(FETCH_APPOINTMENTS_DOCTORS, getDoctors);
}

export function* onDeleteAppointments() {
  yield takeEvery(ON_DELETE_APPOINTMENTS, deleteAppointments);
}

export default function* rootSaga() {
  yield all([
    fork(createSchedule),
    fork(fetchAppointmentsBetweenDates),
    fork(fetchDoctors),
    fork(onDeleteAppointments),
  ]);
}



// WEBPACK FOOTER //
// ./sagas/Appointment.js